"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var toolkit_1 = require("@reduxjs/toolkit");
var meSlice_1 = __importDefault(require("./reducers/meSlice"));
var repositorySlice_1 = __importDefault(require("./reducers/repositorySlice"));
var promoSlice_1 = __importDefault(require("./reducers/promoSlice"));
var workspaceSlice_1 = __importDefault(require("./reducers/workspaceSlice"));
var faqSlice_1 = __importDefault(require("./reducers/faqSlice"));
var teamSlice_1 = __importDefault(require("./reducers/teamSlice"));
var taskSlice_1 = __importDefault(require("./reducers/taskSlice"));
var announcementSlice_1 = __importDefault(require("./reducers/announcementSlice"));
var devSlice_1 = __importDefault(require("./reducers/devSlice"));
var settingSlice_1 = __importDefault(require("./reducers/settingSlice"));
var memberSlice_1 = __importDefault(require("./reducers/memberSlice"));
var myInviteSlice_1 = __importDefault(require("./reducers/myInviteSlice"));
var analytics_1 = __importDefault(require("./services/analytics"));
var topicSlice_1 = __importDefault(require("./reducers/topicSlice"));
var commentSlice_1 = __importDefault(require("./reducers/commentSlice"));
var internalAdminsSlice_1 = __importDefault(require("./reducers/internalAdminsSlice"));
var playbookSlice_1 = __importDefault(require("./reducers/playbookSlice"));
var faqCategorySlice_1 = __importDefault(require("./reducers/faqCategorySlice"));
var featureFlagSlice_1 = __importDefault(require("./reducers/featureFlagSlice"));
var notificationSlice_1 = __importDefault(require("./reducers/notificationSlice"));
var rootReducer = (0, toolkit_1.combineReducers)({
    analytics: analytics_1.default,
    me: meSlice_1.default,
    repository: repositorySlice_1.default,
    workspace: workspaceSlice_1.default,
    team: teamSlice_1.default,
    faq: faqSlice_1.default,
    faqCategory: faqCategorySlice_1.default,
    task: taskSlice_1.default,
    topic: topicSlice_1.default,
    comment: commentSlice_1.default,
    announcement: announcementSlice_1.default,
    setting: settingSlice_1.default,
    development: devSlice_1.default,
    member: memberSlice_1.default,
    myInvite: myInviteSlice_1.default,
    internalAdmins: internalAdminsSlice_1.default,
    promo: promoSlice_1.default,
    playbook: playbookSlice_1.default,
    featureFlag: featureFlagSlice_1.default,
    notification: notificationSlice_1.default,
});
exports.default = rootReducer;
